import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig } from '@ngrx/data';
import { throwError } from 'rxjs';
import { ajax, AjaxConfig, AjaxError, AjaxResponse } from 'rxjs/ajax';
import { catchError, map } from 'rxjs/operators';

function HandleAjaxResponse(res: AjaxResponse<any>) {
    return res.response;
}

function HandleAjaxError(err: AjaxError) {
    console.log('[error] AjaxService:', JSON.stringify(err));
    if (err.response) return throwError(() => err.response.message);
    if (err.message) return throwError(() => err.message);
    return throwError(() => err);
}

const headers = {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
};

// ngrx/data domain config
export const defaultDataServiceConfig: DefaultDataServiceConfig = {
    // root: 'https://b597au2483.execute-api.eu-west-1.amazonaws.com/staging/api/sway',
    root: 'https://api.publicapis.org',
    timeout: 3000, // request timeout
};

@Injectable({
    providedIn: 'root',
})
export class AjaxService {
    constructor() {}

    public get<T = any>(url: string) {
        return this.ajax<T>('GET', url);
    }

    public put<T = any>(url: string, body?: any) {
        return this.ajax<T>('PUT', url, body);
    }

    public post<T = any>(url: string, body?: any) {
        return this.ajax<T>('POST', url, body);
    }

    public patch<T = any>(url: string, body?: any) {
        return this.ajax<T>('PATCH', url, body);
    }

    public delete<T = any>(url: string) {
        return this.ajax<T>('DELETE', url);
    }

    private ajax<T = any>(method: string, url: string, body?: any) {
        const request: AjaxConfig = {
            method,
            url,
            body,
            headers,
        };
        return ajax(request).pipe(map(HandleAjaxResponse), catchError(HandleAjaxError));
    }
}
